import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useMemo } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Form } from 'foundations-components/transitional/components/Form';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CodeEntryForm = ({
  codeLength,
  code,
  closeModal = () => {},
  isInvalidCodeAlertVisible,
  hideInvalidCodeAlert,
  isVerifying,
  isRequestingCode,
  onCodeChange,
  onSubmit,
  type = 'default'
}) => {
  const disabled = useMemo(() => !code || code.length < codeLength || isInvalidCodeAlertVisible || isVerifying || isRequestingCode, [code, codeLength, isInvalidCodeAlertVisible, isVerifying, isRequestingCode]);
  const onClick = useCallback(() => {
    hideInvalidCodeAlert();
    closeModal();
  }, [hideInvalidCodeAlert, closeModal]);
  return /*#__PURE__*/_jsxs(Form, {
    onSubmit: onSubmit,
    alignItems: "start",
    children: [/*#__PURE__*/_jsx(FormControl, {
      error: isInvalidCodeAlertVisible,
      textAlign: "left",
      htmlFor: "codeEntry",
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "twoFactorV4.code.label"
      }),
      inlineSize: "100%",
      validationMessage: isInvalidCodeAlertVisible ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "twoFactorV4.code.invalid"
      }) : undefined,
      children: /*#__PURE__*/_jsx(TextInput, {
        block: true,
        "data-test-id": "two-factor-code-input",
        disabled: isVerifying || isRequestingCode,
        error: isInvalidCodeAlertVisible,
        id: "codeEntry",
        onChange: onCodeChange,
        placeholder: codeLength === 6 ? I18n.text(`twoFactorV4.code.sixDigitPlaceholder`) : I18n.text(`twoFactorV4.code.longPlaceholder`),
        tabIndex: 1,
        value: code
      })
    }), isVerifying || isRequestingCode ? /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      minHeight: "56px"
    }) : type === 'modal' ? /*#__PURE__*/_jsxs(ButtonWrapper, {
      marginBlock: "600",
      children: [/*#__PURE__*/_jsx(Button, {
        disabled: disabled,
        use: "primary",
        type: "submit",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "twoFactorV4.code.modal.submit"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "secondary",
        onClick: onClick,
        type: "button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "twoFactorV4.code.modal.cancel"
        })
      })]
    }) : /*#__PURE__*/_jsx(Button, {
      block: true,
      "data-test-id": "2fa-code-submit",
      disabled: disabled,
      marginBlockStart: "400",
      type: "submit",
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "twoFactorV4.code.submit"
      })
    })]
  });
};